/**
 * Convert bounded flat REST records into a predictable editor-preview tree.
 *
 * Missing parents are treated as roots because include/exclude rules and the
 * preview cap can legitimately omit an ancestor.
 *
 * @param {Array} items Flat records with id and parent properties.
 * @return {Array} Root preview nodes.
 */
export function buildPreviewTree(items) {
	const nodes = new Map();

	for (const item of Array.isArray(items) ? items : []) {
		const id = Number.parseInt(item?.id, 10);
		if (!Number.isInteger(id) || id <= 0 || nodes.has(id)) {
			continue;
		}

		nodes.set(id, {
			id,
			parent: Math.max(0, Number.parseInt(item?.parent, 10) || 0),
			title: String(item?.title || ''),
			url: String(item?.url || ''),
			children: [],
		});
	}

	const roots = [];
	for (const node of nodes.values()) {
		const parent = nodes.get(node.parent);
		if (parent && parent.id !== node.id) {
			parent.children.push(node);
		} else {
			roots.push(node);
		}
	}

	return roots;
}
